const areArraysOfValuesEquivalent = (arr1: string[], arr2: string[]) => {
  if (arr1.length !== arr2.length) {
    return false;
  }
  const sortedArr1 = [...arr1].sort();
  const sortedArr2 = [...arr2].sort();

  return sortedArr1.every((value, index) => value === sortedArr2[index]);
};

export const doUnsavedValuesExist = (
  localValues: string | string[],
  existedValues?: unknown
) => {
  const onlyNotSavedValuesExists = !existedValues && !!localValues.length;

  if (typeof localValues === 'string') {
    return onlyNotSavedValuesExists || localValues !== existedValues;
  }

  const existedValuesAreNotEquivalent =
    existedValues &&
    Array.isArray(existedValues) &&
    !areArraysOfValuesEquivalent(existedValues, localValues);

  return onlyNotSavedValuesExists || !!existedValuesAreNotEquivalent;
};
